class ResponsiveImage {
    attach(scope) {
        if (!this.supportsResponsiveImages()) return;
        this.scope = scope;
        this.getResponsiveImages().forEach(figure => {
            this.unhide(figure); 
            if (this.shouldLazyLoad(figure)) {
                this.lazyLoad(figure);
            }
        });
    }

    supportsResponsiveImages() {
        return ('sizes' in document.createElement('img'));
    }

    getResponsiveImages() {
        return [].slice.call(this.scope.querySelectorAll('.news-vj-component-responsive-image'));
    }

    unhide(figure) {
        figure.removeAttribute('style'); // shows srcset if lazyload=false, else placeholder-image
    }

    shouldLazyLoad(figure) {
        return figure.getAttribute('data-lazy-load') === 'true';
    }

    lazyLoad(figure) {
        if (!this.scrollCallback) {
            this.scrollCallback = this.loadImagesIfInView.bind(this); // required to removeEventListener later
            this.scope.addEventListener('scroll', this.scrollCallback, false);
            this.loadImagesIfInView(); // trigger immediately in case any are in view already
        }
    }
    
    loadImagesIfInView() {
        this.imagesToLazyLoad = this.imagesToLazyLoad || this.getResponsiveImages().filter(figure => figure.getAttribute('data-lazy-load') === 'true');
        for (let i = 0; i < this.imagesToLazyLoad.length; i++) { // not forEach so that we can break
            const figure = this.imagesToLazyLoad[i];
            if (this.imageIsInView(figure)) {
                this.loadImage(figure);
                this.removeImageFromLazyLoadQueue(i);
                break; // images in DOM are top to bottom. Only lazy-load the first one that's in view. Also avoids complications after changing the this.imagesToLazyLoad array.
            }
        };
    }

    imageIsInView(image) {
        const boundingRect = image.getBoundingClientRect();
        return (boundingRect.top >= 0) && (boundingRect.bottom - boundingRect.height <= window.innerHeight);
    } 

    loadImage(figure) {
        this.getSourcesFor(figure).forEach(source => {
            source.setAttribute('srcset', source.getAttribute('data-srcset'));
        });
    }

    getSourcesFor(figure) {
        return [].slice.call(figure.querySelectorAll('source'));
    }

    removeImageFromLazyLoadQueue(indexOfImage) {
        this.imagesToLazyLoad.splice(indexOfImage, 1);
        if (this.imagesToLazyLoad.length === 0) {
            this.scope.removeEventListener('scroll', this.scrollCallback, false);
            this.scrollCallback = false;
        }
    }
}

export default new ResponsiveImage();
